import { render } from "./DocumentActionButtons.vue?vue&type=template&id=bf4b7066&scoped=true&ts=true"
import script from "./DocumentActionButtons.vue?vue&type=script&lang=ts"
export * from "./DocumentActionButtons.vue?vue&type=script&lang=ts"

import "./DocumentActionButtons.vue?vue&type=style&index=0&id=bf4b7066&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4b7066"]])

export default __exports__